

































































































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { DxDataGrid, DxColumn, } from 'devextreme-vue/data-grid';
import moment from "moment";

// Servicios
import { logService } from '@/services/LogService';
import { eventService } from "@/services/EventService";
import { toastService } from '@/services/ToastService';
import GenericService from '@/services/GenericService';
import GenericStore from '@/services/GenericStore';

import DialogForm from "@/components/DialogForm.vue";
import DialogConfirm from "@/components/DialogConfirm.vue";
import GridOData from "@/components/GridOData.vue";

import { Sorteo } from '@/model/Sorteo';
import { DecimoService } from '@/services/DecimoService';
import { Decimo } from '@/model/Decimo';
import { Response } from '@/model/Response';

@Component({
  components: {
    DxDataGrid,
    DxColumn,
    GridOData,
    DialogConfirm,
    DialogForm
  },
})
export default class SorteoNumerosSacados extends Vue {
  visibleConfirm: boolean = false;
  cancelEventConfirm: string ="NumerosSacados-DialogConfirm-Cancel";
  acceptEventConfirm: string ="NumerosSacados-DialogConfirm-Accept";

  visible: boolean = false;

  decimoService: any | DecimoService = new DecimoService();

  @Prop({ type: Number, default: 0 })
  idSorteo!: number;

  decimoEliminar: Decimo | any;

  idGrid: string = "gridNumerosSacados";

  loadDataSource: any | Function;

  columns: any = [
    {
      dataField: "Numero",
      caption: "Números sacados",
      width: 150
    },
    {
      dataField: "FechaExtraccion",
      caption: "Fecha de extracción",
      width: 170,
      dataType: "date",
      format: "dd/MM/yyyy",
      sortOrder: "desc"
    },
    {
      dataField: "MetodoExtraccion",
      caption: "Método de extracción",
      loadAll: true
    }
  ];

  editing: any = {
    mode: "cell",
    allowAdding: false,
    allowUpdating: false,
    allowDeleting: false
  };

  width: string = "100%";
  height: number = 500;
  headerFilter: any = { visible: true };

  nameEventRefresh: string = "GridSacados-Refresh"

  numeroSacarManualmente: string = "";

  visibleBuscar: boolean = false;
  buscado: boolean = false;
  encontrado: boolean = false;
  primeraCifraBuscar: string = "";
  segundaCifraBuscar: string = "";
  terceraCifraBuscar: string = "";
  cuartaCifraBuscar: string = "";
  quintaCifraBuscar: string = "";
  decimoBuscar: Decimo | any = null;
  visibleConfirmBuscar: boolean = false;
  cancelEventConfirmBuscar: string ="NumerosSacados-DialogConfirmBuscar-Cancel";
  acceptEventConfirmBuscar: string ="NumerosSacados-DialogConfirmBuscar-Accept";

  created(){
    this.loadDataSource = async (queryString: string) =>{
      return await this.decimoService.sacados(this.idSorteo, queryString !== undefined ? queryString : "?$count=true");
    }

    eventService.on("GridOData-Delete", (decimo: Decimo) =>{
      this.decimoEliminar = decimo;
      this.visibleConfirm = true;
    });

    eventService.on(this.cancelEventConfirm, (obj: any) => {
      this.visibleConfirm = false;
      this.decimoEliminar = {};
    });

    eventService.on(this.acceptEventConfirm, (obj: any) => {
      eventService.emit("LoadPanel", true);
      this.visibleConfirm = false;
      this.decimoEliminar.MetodoExtraccion = "";
      this.decimoEliminar.Sacado = false;
      this.decimoEliminar.Stock++;

      this.decimoService.update(this.decimoEliminar).then((res: Decimo) =>{
        logService.Info("Número eliminado correctamente - Sorteo: "+this.idSorteo,"SorteoNumerosSacados.vue - create() - Eliminar");
        toastService.success("Número eliminado correctamente.");
        eventService.emit(this.nameEventRefresh, true);
        this.decimoEliminar = {};
        eventService.emit("LoadPanel", false);
      })
    });

    eventService.on(this.cancelEventConfirmBuscar, (obj: any) => {
      this.visibleConfirmBuscar = false;
    });

    eventService.on(this.acceptEventConfirmBuscar, (obj: any) => {
      eventService.emit("LoadPanel", true);
      this.decimoBuscar.MetodoExtraccion = "";
      this.decimoBuscar.Sacado = false;
      this.decimoBuscar.Stock++;

      this.decimoService.update(this.decimoBuscar).then((res: Decimo) =>{
        this.visibleConfirmBuscar = false;
        logService.Info("Número eliminado correctamente - Sorteo: "+this.idSorteo,"SorteoNumerosSacados.vue - create() - Buscar");
        toastService.success("Número eliminado correctamente.");
        eventService.emit(this.nameEventRefresh, true);
        this.visibleBuscar = false;
        this.decimoBuscar = null;
        this.buscado = false;
        this.encontrado = false;
        this.resetBuscar();
        eventService.emit("LoadPanel", false);
      })
    });
  }

  refresh(){
    logService.Info("Inicio - Sorteo: "+this.idSorteo,"SorteoNumerosSacados.vue - refresh()");
    eventService.emit(this.nameEventRefresh, true);
  }

  destroyed(){
    eventService.off("GridOData-Delete");
    eventService.off(this.cancelEventConfirm);
    eventService.off(this.acceptEventConfirm);
    eventService.off("SacarManualmente-Save");
  }

  saveSacarManualmente(){
    logService.Info("Inicio - Sorteo: "+this.idSorteo,"SorteoNumerosSacados.vue - saveSacarManualmente()");
    eventService.emit("LoadPanel", true);
    
    this.decimoService.sacarManualmente(this.idSorteo, this.numeroSacarManualmente)
      .then((res: Response) => {
        this.visible = false;
        this.numeroSacarManualmente = "";
        if(res.Message !== "" && res.Message !== null){
          toastService.warning(res.Message);
        }else{
          logService.Info("Número sacado correctamente - Numero: "+this.numeroSacarManualmente+" - Sorteo: "+this.idSorteo,"SorteoNumerosSacados.vue - saveSacarManualmente()");
          toastService.success("Número sacado correctamente.");
          eventService.emit(this.nameEventRefresh, true);
        }
        eventService.emit("LoadPanel", false);
      })
      .catch((err: any) => {
        this.visible = false;
        logService.Error("Ha habido un problema al sacar el número manualmente - Numero: "+this.numeroSacarManualmente+" - Sorteo: "+this.idSorteo,"SorteoNumerosSacados.vue - saveSacarManualmente()", null, err);
        toastService.error("Ha habido un problema al sacar el número manualmente.");
        eventService.emit("LoadPanel", false);
      });
  }

  reset(){
    this.numeroSacarManualmente = "";
  }

  buscar(){
    logService.Info("Inicio - Sorteo: "+this.idSorteo,"SorteoNumerosSacados.vue - buscar()");
    eventService.emit("LoadPanel", true);
    this.buscado = true;
    this.decimoBuscar = null;
    this.encontrado = false;
    let numero = this.primeraCifraBuscar + this.segundaCifraBuscar + this.terceraCifraBuscar + this.cuartaCifraBuscar + this.quintaCifraBuscar;
    this.decimoService.sacadoByNumero(this.idSorteo, numero)
    .then((res: any) => {

      if(res.Body === null){
          this.encontrado = false;
      }else{
        if(res !== null){
          this.decimoBuscar = res;
          this.encontrado = true;
        }else{
          this.encontrado = false;
        }
      }
      eventService.emit("LoadPanel", false);
    })
    .catch((err: any) => {
      this.visibleBuscar = false;
      logService.Error("Ha habido un problema al buscar el número - Sorteo: "+this.idSorteo,"SorteoNumerosSacados.vue - buscar()", null, err);
      toastService.error("Ha habido un problema al buscar el número.");
      eventService.emit("LoadPanel", false);
    });
  }

  resetBuscar(){
    this.primeraCifraBuscar = "";
    this.segundaCifraBuscar = "";
    this.terceraCifraBuscar = "";
    this.cuartaCifraBuscar = "";
    this.quintaCifraBuscar = "";
  }

  abrirBuscar(){
    logService.Info("Inicio - Sorteo: "+this.idSorteo,"SorteoNumerosSacados.vue - abrirBuscar()");
    if(!this.visibleBuscar){
      this.visibleBuscar = true;
      this.visible = false;
    }else{
      this.visibleBuscar = false;
      this.primeraCifraBuscar = "";
      this.segundaCifraBuscar = "";
      this.terceraCifraBuscar = "";
      this.cuartaCifraBuscar = "";
      this.quintaCifraBuscar = "";
      this.decimoBuscar = null;
      this.buscado = false;
      this.encontrado = false;
    }
  }
}
